module.exports = __webpack_public_path__ + "static/media/SaxonyCrest.2ae629ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/SaxonyCrest.png
// module id = 137
// module chunks = 0